import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";

export type BreadcrumbVariant = "default" | "dark";

interface BreadcrumbNavProps {
  variant?: BreadcrumbVariant;
}

export const BreadcrumbNav = styled.nav<BreadcrumbNavProps>`
  width: 100%;
  margin: 0 auto;
`;

interface BreadcrumbContainerProps {
  variant?: BreadcrumbVariant;
}

export const BreadcrumbContainer = styled.ol<BreadcrumbContainerProps>`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  background: transparent;
  padding: 0;
  width: ${(props) => (props.variant === "dark" ? "auto" : "1200px")};
  margin: ${(props) => (props.variant === "dark" ? "0" : "0 auto")};

  @media ${deviceType.mobile} {
    padding: 0 20px;
    width: auto;
    margin: 0;
  }
`;

interface BreadcrumbItemProps {
  isActive?: boolean;
  variant?: BreadcrumbVariant;
}

export const BreadcrumbItem = styled.li<BreadcrumbItemProps>`
  color: ${(props) => {
    if (props.variant === "dark") {
      return props.isActive ? "#ffffff" : "#b3c6d9";
    }
    return "#000";
  }};
  font-size: 14px;
  font-weight: ${(props) => (props.isActive ? "500" : "400")};
  line-height: 1.4;

  @media ${deviceType.mobile} {
    font-size: 12px;
  }
`;

interface BreadcrumbLinkProps {
  variant?: BreadcrumbVariant;
}

export const BreadcrumbLink = styled.a<BreadcrumbLinkProps>`
  color: ${(props) => (props.variant === "dark" ? "#b3c6d9" : "#000")};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => (props.variant === "dark" ? "#ffffff" : "#000")};
    text-decoration: underline;
  }

  &:visited {
    color: ${(props) => (props.variant === "dark" ? "#b3c6d9" : "#000")};
  }

  &:focus {
    outline: 2px solid
      ${(props) => (props.variant === "dark" ? "#ffffff" : "#000")};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

interface BreadcrumbSeparatorProps {
  variant?: BreadcrumbVariant;
}

export const BreadcrumbSeparator = styled.span<BreadcrumbSeparatorProps>`
  color: ${(props) => (props.variant === "dark" ? "#b3c6d9" : "#000")};
  margin: 0 8px;
  font-size: 14px;
  user-select: none;
  font-weight: 400;

  @media ${deviceType.mobile} {
    margin: 0 6px;
    font-size: 12px;
  }
`;
